










import iconUrl from 'helpers/icons';
import { VueCustom } from 'vue-custom';
import { WorkspaceElement } from 'types';

export default VueCustom.extend({
  name: 'base-box',
  props: {
    data: Object as PropType<WorkspaceElement>,
  },
  computed: {
    id(): WorkspaceElement['id'] {
      return this.data.id;
    },
    iconUrl(): string {
      return iconUrl(this.data.elementId);
    },
    style(): Partial<CSSStyleDeclaration> {
      const { x, y } = this.data.position;
      return {
        position: 'absolute',
        top: `${ y }px`,
        left: `${ x }px`,
      };
    },
  },
});
